var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 25.6475H0.151367V27.0003H26.6V25.6475Z",
    fill: "#573A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6157 23.7314H1.13867V25.0843H25.6157V23.7314Z",
    fill: "#573A7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97069 2.57376L7.68066 2.0918L6.74277 2.65619L7.03279 3.13815L7.97069 2.57376Z",
    fill: "#573A7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33934 3.55423L6.04932 3.07227L1.61623 5.73994L1.90626 6.2219L6.33934 3.55423Z",
    fill: "#573A7A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8994 5.09192L20.1006 2.80762L19.8107 3.28968L23.6096 5.57398L23.8994 5.09192Z",
    fill: "#573A7A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3808 2.37387L18.3774 1.77051L18.0876 2.25257L19.091 2.85593L19.3808 2.37387Z",
    fill: "#573A7A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5747 5.82147H12.4151L11.9949 4.70801L11.5747 5.82147Z",
    fill: "#573A7A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87661 5.62114H9.20068V6.27263H9.87661C10.0972 6.27263 10.2304 6.15 10.2304 5.94688C10.2304 5.77178 10.1076 5.62114 9.87661 5.62114ZM10.1848 4.95936C10.1848 4.78783 10.0656 4.6582 9.85903 4.6582H9.20068V5.26053H9.85903C10.0656 5.26053 10.1848 5.13801 10.1848 4.95936Z",
    fill: "#573A7A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2974 0L0 7.99593H26.5921L13.2974 0ZM9.97134 6.63379H8.79113V4.2981H9.93975C10.3707 4.2981 10.6052 4.56425 10.6052 4.89328C10.6052 5.184 10.416 5.38355 10.199 5.42914C10.4512 5.46759 10.6508 5.7163 10.6508 5.99988C10.6509 6.36407 10.4124 6.63379 9.97134 6.63379ZM12.7023 6.63379L12.5306 6.18199H11.4591L11.2875 6.63379H10.8216L11.7393 4.2981H12.2504L13.168 6.63379H12.7023ZM15.4439 6.63379H15.0481L13.8295 4.96331V6.63379H13.4197V4.2981H13.8399L15.0341 5.91584V4.2981H15.4439V6.63379ZM16.5571 5.64627L16.3505 5.88783V6.63379H15.9408V4.2981H16.3505V5.40813L17.2646 4.2981H17.7722L16.8232 5.39756L17.8458 6.63379H17.3382L16.5571 5.64627Z",
    fill: "#573A7A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6245 8.55859H1.00684V9.95359H25.6245V8.55859Z",
    fill: "#573A7A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 1,
    height: 11,
    fill: "#573A7A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 1,
    height: 11,
    fill: "#573A7A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 1,
    height: 11,
    fill: "#573A7A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11,
    width: 1,
    height: 11,
    fill: "#573A7A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 11,
    width: 1,
    height: 11,
    fill: "#573A7A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 11,
    width: 1,
    height: 11,
    fill: "#573A7A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIco);
export default __webpack_public_path__ + "static/media/bankIco.1a7e0066365654bd11b60ccadebcc799.svg";
export { ForwardRef as ReactComponent };